export enum ImageVariant {
  /** 240 x 135 */
  Thumbnail = 'thumbnail',
  /** 550 x 350 */
  Hero = 'hero',
  /** 972 x 578 */
  Detail = 'detail',
  /** 50 x 50 */
  SquareLogoSmall = 'square_logo_small',
  /** 100 x 100 */
  SquareLogoMedium = 'square_logo_medium',
  /** 200 x 200 */
  SquareLogoLarge = 'square_logo_large',
  /** object fit: contain */
  Contain = 'contain',
}
